function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import { GlobalManagerMixin } from './GlobalManagerMixin';

export var LoadingSpinner = /*#__PURE__*/function () {

  function LoadingSpinner() {_classCallCheck(this, LoadingSpinner);
    this.domElement = null;
  }_createClass(LoadingSpinner, [{ key: "createDom", value: function createDom(

    container) {
      var _document = this.getDocument();
      var loadSpinner = _document.createElement("div");
      loadSpinner.className = "spinner";
      container && container.appendChild(loadSpinner);

      // Generate circles for spinner
      for (var i = 1; i <= 3; i++) {
        var spinnerContainer = _document.createElement("div");
        spinnerContainer.className = "bounce" + i;
        //spinnerContainer.style['background-color'] = 'red';
        loadSpinner.appendChild(spinnerContainer);
      }

      this.domElement = loadSpinner;
      this.hide();
      return loadSpinner;
    } }, { key: "show", value: function show()

    {
      if (this.domElement) {
        this.domElement.style.display = "block";
      }
    } }, { key: "hide", value: function hide()

    {
      if (this.domElement) {
        this.domElement.style.display = "None";
      }
    } }, { key: "destroy", value: function destroy()

    {
      this.domElement = null;
    } }]);return LoadingSpinner;}();


GlobalManagerMixin.call(LoadingSpinner.prototype);